
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/team-standings",
      function () {
        return require("private-next-pages/[league]/team-standings/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/team-standings"])
      });
    }
  